export default "__VITE_ASSET__StGJX4MW__"